import { render, staticRenderFns } from "./StatusServiceReservation.vue?vue&type=template&id=195b9a0e&"
import script from "./StatusServiceReservation.vue?vue&type=script&lang=js&"
export * from "./StatusServiceReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports